import moment from 'moment'

// global config
export default {
  helpers: {
    formatDate: (timestamp) => {
      return moment(timestamp).format('MM/DD/YYYY');
    },
    formatDateShort: (timestamp) => {
      return moment(timestamp).format('MM/DD/YY');
    }
  },
  dictionaries: {
    provinces: {
      "AL": "Alabama",
      "AK": "Alaska",
      "AS": "American Samoa",
      "AZ": "Arizona",
      "AR": "Arkansas",
      "CA": "California",
      "CO": "Colorado",
      "CT": "Connecticut",
      "DE": "Delaware",
      "DC": "District Of Columbia",
      "FM": "Federated States Of Micronesia",
      "FL": "Florida",
      "GA": "Georgia",
      "GU": "Guam",
      "HI": "Hawaii",
      "ID": "Idaho",
      "IL": "Illinois",
      "IN": "Indiana",
      "IA": "Iowa",
      "KS": "Kansas",
      "KY": "Kentucky",
      "LA": "Louisiana",
      "ME": "Maine",
      "MH": "Marshall Islands",
      "MD": "Maryland",
      "MA": "Massachusetts",
      "MI": "Michigan",
      "MN": "Minnesota",
      "MS": "Mississippi",
      "MO": "Missouri",
      "MT": "Montana",
      "NE": "Nebraska",
      "NV": "Nevada",
      "NH": "New Hampshire",
      "NJ": "New Jersey",
      "NM": "New Mexico",
      "NY": "New York",
      "NC": "North Carolina",
      "ND": "North Dakota",
      "MP": "Northern Mariana Islands",
      "OH": "Ohio",
      "OK": "Oklahoma",
      "OR": "Oregon",
      "PW": "Palau",
      "PA": "Pennsylvania",
      "PR": "Puerto Rico",
      "RI": "Rhode Island",
      "SC": "South Carolina",
      "SD": "South Dakota",
      "TN": "Tennessee",
      "TX": "Texas",
      "UT": "Utah",
      "VT": "Vermont",
      "VI": "Virgin Islands",
      "VA": "Virginia",
      "WA": "Washington",
      "WV": "West Virginia",
      "WI": "Wisconsin",
      "WY": "Wyoming"
    },
    apparelSizes: ["XXS", "XS", "S", "M", "L", "XL", "XXL"],
    footwearSizes: ["3", "4", "4.5", "5", "5.5", "6", "6.5", "7", "7.5", "8", "8.5", "9", "9.5", "10", "10.5", "11", "11.5", "12", "12.5", "13", "14", "15"],
    headwearSizes: ["OS", "S/M", "L/XL", "7", "7⅛", "7¼", "7⅜", "7½", "7⅝", "7¾", "7⅞"],
    notificationPreferences: {
      all: {
        value: 'all',
        label: 'All (Shipping, Delivery & Product Information)'
      },
      shipping: {
        value: 'shipping_delivery_only',
        label: 'Shipping & Delivery Information Only'
      },
      none: {
        value: 'none',
        label: 'None'
      }
    }
  }
}
